export const TOGGLE_CREATE_MODAL_LABEL = 'TOGGLE_CREATE_MODAL_LABEL';
export const TOGGLE_EDIT_MODAL_LABEL = 'TOGGLE_EDIT_MODAL_LABEL';
export const TOGGLE_GET_MODAL_BOARD_LABELS = 'TOGGLE_GET_MODAL_BOARD_LABELS';
